<template lang="html">
  <div class="">
    <h3>Fortæl først lidt om din virksomhed</h3>
    <div class="grid">
      <div class="box-left">
        <div class="company-info">
          <p>Hvor mange ansatte har i?</p>
          <div class="company-info-buttons">
            <button type="button" class="minus" @click.prevent.default="employeesMinus" :disabled="employeesCounter < 1">-</button>
            <span class="company-info-value">{{firm.employees}}</span>
            <button type="button" class="plus" @click.prevent.default="employeesPlus" :disabled="employeesCounter > (employees.length - 2)">+</button>
          </div>
        </div>
        <div class="company-info">
          <p>Hvor mange lokationer har i?</p>
          <div class="company-info-buttons">
            <button type="button" class="minus" @click.prevent.default="locationMinus" :disabled="locationCounter < 1">-</button>
            <span class="company-info-value">{{firm.location}}</span>
            <button type="button" class="plus" @click.prevent.default="locationPlus" :disabled="locationCounter > (location.length - 2)">+</button>
          </div>
        </div>
      </div>
      <div class="box-right">
        <div class="company-info">
          <p>Hvor mange kvadratmeter har i?</p>
          <div class="company-info-buttons">
            <button type="button" class="minus" @click.prevent.default="squareMinus" :disabled="squareMetersCounter < 1 ">-</button>
            <span class="company-info-value">{{firm.sqm}}</span>
            <button type="button" class="plus" @click.prevent.default="squarePlus" :disabled="squareMetersCounter >  (squareMeters.length - 2)">+</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Marked from 'marked';
import {mapGetters} from 'vuex';
import {mapSetters} from 'vuex';
import {mapActions} from 'vuex';

export default {
  name: 'BusinessInfo',
  data () {
    return {
      msg: 'Overskrift',
      squareMeters: ["0 - 1500 m2", "1500 - 6000 m2", "over 6000 m2"],
      location: ["1 - 2", "3 - 5", "6 - over"],
      employees: ["0 - 10", "10 - 50", "50 - 100", "100 - over"],
    }
  },
  computed: {
    ...mapGetters([
      'survey',
      'whatPop',
      'globalC',
      'spinner',
      'surveyIsActive',
      'firm',
      'beginFlow',
      "squareMetersCounter",
      "locationCounter",
      "employeesCounter"
    ])
  },
  methods: {
    ...mapActions([
      'setSurveyActive',
      'setFirm',
      'setBeginFlow'
    ]),
    squarePlus(){
      this.$store.state.global.squareMetersCounter++
      if(this.squareMetersCounter < 3){
        this.firm.sqm = this.squareMeters[this.squareMetersCounter]
      }else{
        this.$store.state.global.squareMetersCounter = 2
      }
    },
    squareMinus(){
      this.$store.state.global.squareMetersCounter = this.squareMetersCounter - 1
      if(this.squareMetersCounter >= 0){
        this.firm.sqm = this.squareMeters[this.squareMetersCounter]
      }else{
        this.$store.state.global.squareMetersCounter = 0
      }
    },
    employeesPlus(){
      this.$store.state.global.employeesCounter++
      console.log(Number(this.employees.length));
      this.firm.employees = this.employees[this.employeesCounter]
    },
    employeesMinus(){
      this.$store.state.global.employeesCounter = this.employeesCounter - 1
      if(this.employeesCounter >= 0){
        this.firm.employees = this.employees[this.employeesCounter]
      }else{
        this.$store.state.global.employeesCounter = 0
      }
    },
    locationPlus(){
      this.$store.state.global.locationCounter++
      if(this.locationCounter < 3){
        this.firm.location = this.location[this.locationCounter]
      }else{
        this.$store.state.global.locationCounter = 2
      }
    },
    locationMinus(){
      this.$store.state.global.locationCounter = this.locationCounter - 1
      if(this.locationCounter >= 0){
        this.firm.location = this.location[this.locationCounter]
      }else{
        this.$store.state.global.locationCounter = 0
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="scss" scoped>
.grid{
  display: flex;
  flex-wrap: wrap;
}
.company-info{

}
.company-info-value{
  font-size: 2rem;
  padding-left:20px;
  padding-right:20px;
  margin: auto;
}
.company-info-buttons{
  margin-top: 10px;
 display: flex;
 align-items: center;
 margin-bottom: 7rem;
}
.box-left{
  width:340px;
  margin-right: 70px;
  @media(max-width: 500px){
    width:100%;
    margin-right: 0px;
  }
}
.box-right{
  width:360px;
  @media(max-width: 500px){
    width:100%;
    margin-right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modular/BusinessInfo.vue